import { List, Datagrid, TextField } from 'react-admin'
import { ExtraPagination } from './utils'

export const RoutingList = (props) => (
  <List exporter={false} pagination={<ExtraPagination />}>
    <Datagrid bulkActionButtons={false}>
      <TextField source="frontapp_tag" label="Tag" />
      <TextField source="name" label="Nom" />
      <TextField source="description" label="Description" />
      <TextField source="routing" label="Règle" />
      <TextField source="targets" label="Cible" />
    </Datagrid>
  </List>
)
